import {$http} from '@/utils/https'
import {
    INFO_UPDATE_LOADING,
    SET_USER_SKILLS,
    SET_USER_SKILLS_LOADING,
    UPDATE_AVATAR_LOADING
} from './types/mutation-types';

import {GET_USER_SKILLS, INFO_UPDATE, UPDATE_AVATAR} from './types/action-types';

const state = {
    updateInfoLoading: false,
    avatarUpdateLoading: false,
    userSkills: [],
    userSkillsLoading: false
};

const getters = {
    updateInfoLoading: state => state.updateInfoLoading,
    avatarUpdateLoading: state => state.avatarUpdateLoading,
    userSkills: state => state.userSkills,
    userSkillsLoading: state => state.userSkillsLoading,
};

const actions = {
    [INFO_UPDATE]: async ({dispatch, commit}, payload) => {
        try {
            commit(INFO_UPDATE_LOADING, true);

            const response = await $http.post(`${process.env.VUE_APP_ROOT_USER}profile/personal-data`, payload);
            dispatch('user/GET_USER_DATA', response.data.data, {root: true})
            return response.data.data
        } catch (e) {
            throw e;
        } finally {
            commit(INFO_UPDATE_LOADING, false);
        }
    },
    [UPDATE_AVATAR]: async ({dispatch, commit}, payload) => {
        try {
            commit(UPDATE_AVATAR_LOADING, true);

            const fileResp = await $http.post(`${process.env.VUE_APP_ROOT_FILE}files`, payload);

            const response = await $http.post(`${process.env.VUE_APP_ROOT_USER}profile/avatars`, {
                avatar: fileResp.data.data.src,
                '_method': 'patch'
            });

            dispatch('user/GET_USER_DATA', response.data.data, {root: true})
        } catch (e) {
            throw e;
        } finally {
            commit(UPDATE_AVATAR_LOADING, false);
        }
    },
    [GET_USER_SKILLS]: async ({dispatch, commit}, payload) => {
        try {
            commit(SET_USER_SKILLS_LOADING, true);

            const response = await $http.get(`${process.env.VUE_APP_ROOT_COURSE}my/skills?include=skill`, payload);
            // dispatch('user/SET_USER_SKILLS', response.data.data, {root: true})
        } catch (e) {
            throw e;
        } finally {
            commit(SET_USER_SKILLS_LOADING, false);
        }
    }
};

const mutations = {
    [INFO_UPDATE_LOADING](state, status) {
        state.updateInfoLoading = status;
    },
    [SET_USER_SKILLS](state, data) {
        state.userSkills = data;
    },
    [SET_USER_SKILLS_LOADING](state, status) {
        state.userSkillsLoading = status;
    },
    [UPDATE_AVATAR_LOADING](state, status) {
        state.avatarUpdateLoading = status;
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
